import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'mbnm-filters-dialog',
  templateUrl: './filters-dialog.component.html',
  styleUrls: ['./filters-dialog.component.scss']
})
export class FiltersDialogComponent implements OnInit {

  constructor() { }

  options: any;

  productData: Array<any>;

  productName:string;

  filteredProducts: Array<any>;

  revertOptions(): void {
    this.options.forEach(option => {
      option.selection = option.previousSelection ? option.previousSelection : option.selection;
    });
  }

  ngOnInit() {

  }

  availableProductsChanged(filteredProducts: Array<any>) {
    this.filteredProducts = filteredProducts;
  }
}
